import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '../shared/toast/toast.service';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { RefreshRequestInfo, RefreshResponseInfo } from './data';
import { retry, tap } from 'rxjs/operators';
import { makeUrl } from '../utils/global';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private autoRefreshTimeout: any;

  private REFRESH_URL: string = makeUrl('/auth/refresh');
  private RETRY_TIME: number = 10000;
  private MAX_TRY: number = 6 * 5; // 5 Minutos.

  private tryNumber: number = 0;

  constructor(private http: HttpClient, 
    private router: Router,    
    public auth: AuthService,
    private toast: ToastService) { }

  hasRefreshLimitError(): boolean {
    return this.tryNumber > this.MAX_TRY;
  }

  stopRefreshTimeout(): void {
    clearTimeout(this.autoRefreshTimeout);
  }

 /* logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.stopRefreshTimeout();
    this.router.navigate(['login']);
  }*/
  

  init() {

    return new Promise<void>((resolve, reject) => {
        //console.log("AppInitService.init() called");
        //console.log(this.authRefreshService);
        this.initAutoRefresh(0, resolve);
        //resolve();
        ////do your initialisation stuff here  
        //this.authService.autoRefresh('', resolve);          
    });
  }



  // Inicia mecanimo de atualização automatica de token.
  public initAutoRefresh(delay: number, resolve?: any): void {
    this.tryNumber = 0;
    
    if(localStorage.getItem('isAuthenticated') === 'true') {
      clearTimeout(this.autoRefreshTimeout);
      console.log("initAutoRefresh " + delay);

      this.autoRefreshTimeout = setTimeout(() => {
        this.autoRefresh(resolve);
      }, delay);

    } else {
      // Se usuário não está autenticado não inicia o mesmo.
      if(typeof resolve === 'function') {
        console.log("!initAutoRefresh");
        this.auth.logout();     
        this.router.navigateByUrl(this.router.createUrlTree(['/login']));
        resolve();
      }
    }
  }

  private autoRefresh(resolve: any = null) {

    let refresh = new RefreshRequestInfo(localStorage.getItem('token') ?? '', 
        localStorage.getItem('refreshToken') ?? '');

    console.log('autoRefresh');

    this.http.post<RefreshResponseInfo>(this.REFRESH_URL, refresh, 
      {
        headers: { ignoreLoadingBar: '' }
      }).subscribe((r: RefreshResponseInfo) => {
        console.log('autoRefresh post ok.');
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('isAuthenticationComplete', 'true');
      localStorage.setItem('token', r.token);
      localStorage.setItem('expiresAt', new Date(r.expiresAt).toDateString());
      localStorage.setItem('auxTime', r.auxTime + '');

     // console.log('END RECOVERY TOKEN ' + localStorage.getItem('token'));
     // console.log(r);

      this.tryNumber = 0;

      clearTimeout(this.autoRefreshTimeout);

      this.autoRefreshTimeout = setTimeout(() => {
        this.autoRefresh(localStorage.getItem('expiresAt'));
      }, r.auxTime);

      if(typeof resolve === 'function')
        resolve();

      return r;
    },
    (err: HttpErrorResponse) => {
      // Se não conseguiu recuperar o token, tenta novamente.
      console.log('autoRefresh exception!');

      if(err.status === 401) {
        // Se problema ocorreu devido a não autorização vai para a tela de login.
        this.auth.logout();
        this.router.navigateByUrl(this.router.createUrlTree(['/login']));

        if(typeof resolve === 'function')
          resolve();

        return;
      }

      this.toast.showAuthRefreshError('Não foi possível atualizar a autenticação do usuário. Favor verificar a estabilidade da rede.');

      this.tryNumber = this.tryNumber + 1;

      if(this.tryNumber <= this.MAX_TRY) {
        clearTimeout(this.autoRefreshTimeout);
        this.autoRefreshTimeout = setTimeout(() => {
          this.autoRefresh();
        }, this.RETRY_TIME);
      }

      if(typeof resolve === 'function')
        resolve();
    });
  }
}
